const billing = [
  { id: "SCOPE", label: "SCOPE" },
  { id: "HOURLY", label: "HOURLY" },
  { id: "MIXED", label: "MIXED" },
];

export default billing;
